const CenterCLCGuide = () => {
    return (
        <>
            <div style={{ height: '75vh' }}>
                <iframe width='100%' height='100%' style={{ border: 0 }} src='/pdf/CLC_Guidelines.pdf' />
            </div>
        </>
    );
}

export default CenterCLCGuide;